import { useQuery } from '@apollo/client';

import { useDegreeContext } from 'bundles/degree-home/components/v2/DegreeHomeContext';
import type {
  UseDegreeUpsellQuery as UseDegreeUpsellQueryData,
  UseDegreeUpsellQueryVariables,
} from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/useDegreeUpsell';
import UseDegreeUpsellQuery from 'bundles/degree-home/components/v3-dpm/lib/__queries__/useDegreeUpsell.graphql';

const useDegreeUpsell = () => {
  const { degreeId } = useDegreeContext();

  const variables: UseDegreeUpsellQueryVariables = {
    query: { targetId: degreeId, targetType: 'DEGREE' },
  };

  const { data } = useQuery<UseDegreeUpsellQueryData, UseDegreeUpsellQueryVariables>(UseDegreeUpsellQuery, {
    variables,
    context: { clientName: 'gatewayGql' },
  });

  return {
    degreeUpsellData: data?.UpsellQueries?.getUpsells,
  };
};

export default useDegreeUpsell;
